var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Zeitlicher Verlauf")]),_c('EnrollmentStatistic',{attrs:{"seminar":_vm.seminar}}),_c('h2',[_vm._v("Werbemedien")]),_c('advStatistics',{attrs:{"semId":_vm.seminar.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }